import { Component, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams, ToastController,LoadingController,ModalController } from 'ionic-angular';
import { Configuration } from '../../constants/config';
import { PaymentServiceProvider } from '../../providers/payment-service/payment-service';
import { EmployeeServiceProvider } from '../../providers/employee-service/employee-service';

/**
 * Generated class for the PaymentPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
    selector: 'page-payment',
    templateUrl: 'payment.html',
})
export class PaymentPage {
    @ViewChild('inputCard') inputCard;
    @ViewChild('inputEmployeeCode') inputEmployeeCode;

    card = null;
    creditCard = {number: null, name: null, expDate: null, cvv: null};
    paymentType = 1;
    employeeCode = "";
    employeeData : any = {};
    applyForDiscount : boolean = false;
    sellItems = [];
    total = 0;
    numItems = 0;
    totalItems = 0;
    totalTaxofItems = 0;
    totalDiscount = 0;
    amount = "";
    taxAmount = "";
    requestContent : any = {};
    responseContent : any = {};
    errorWhilePayment : boolean = false;
    canShowErrorPaymentDetails : boolean = false;
    processingTransaction : boolean = false;
    numRetryCard = 0;
    loader : any = {};

    constructor(public navCtrl: NavController, public navParams: NavParams, public toastCtrl: ToastController, public loadingCtrl: LoadingController, public modalCtrl: ModalController, public paymentService: PaymentServiceProvider, public employeeService: EmployeeServiceProvider, public _configuration: Configuration) {

    }

    ionViewWillEnter(){
        this.employeeData = {};
        this.applyForDiscount= false;
        this.sellItems = this.navParams.data.sellItems;
        this.getTotals();

        this.checkTimeOut();
    }


    checkTimeOut() {
        if (this.paymentType == 1 && this.navParams.data.tab2Enabled){
            setTimeout(() => {
                this.checkItems();
            }, 1500);
        }
    }


    /**
     * @Info Back
     * @accept: parameters
     * @return: response
     * @author: sev
     * @date  : 2017-10-28
     */
    back(){
        this.navParams.data.tab1Enabled = true;
        this.navParams.data.tab2Enabled = false;
        this.navCtrl.parent.select(0);
    }


    /**
     * @Info Can show error payment details
     * @accept: parameters
     * @return: response
     * @author: sev
     * @date  : 2017-10-28
     */
    showErrorPaymentDetails(){
        this.canShowErrorPaymentDetails = !this.canShowErrorPaymentDetails;
    }


    /**
     * @Info Show error details of payment
     * @accept: parameters
     * @return: response
     * @author: sev
     * @date  : 2017-10-28
     */
    errorDetails(){
        let req = JSON.stringify(this.requestContent);
        let res = JSON.stringify(this.responseContent);

        /*
        const toast = this.toastCtrl.create({
            message: "REQUEST: "+req+" --- RESPONSE: "+res,
            position: 'top',
            showCloseButton: true
        });
        toast.present();
        */

        const modalData = {details: "REQUEST: "+req+" --- RESPONSE: "+res};
        let modal = this.modalCtrl.create("ModalShowDetailsPage", { data: modalData });
        modal.present();
    }



    /**
     * @Info Check the card input
     * @accept: parameters
     * @return: response
     * @author: sev
     * @date  : 2017-10-22
     */
    checkItems(){

        //(ionBlur)='checkItems()'

        if (this.card){

            this.numRetryCard++;

            let cardExpiration = null;
            let cardName = null;
            let cardNumber = null;
            let verifyProcessOK = true;

            let posDate = -1;
            let posName = -1;
            let posName_2 = -1;
            let lastName = "";
            let nameOnCard = "";
            let posLastName = -1;
            let posName2 = -1;
            let name = "";
            let cardExpirationMonth = "";
            let cardExpirationYear = "";
            let posNumber = -1;

            // Verify Card

            // Check Ini
            if (verifyProcessOK && this.card.substring(0,1)!="%") {
                verifyProcessOK = false;
            }

            // Check End
            if (verifyProcessOK && this.card.substring(this.card.length-1, this.card.length)!="?") {
                verifyProcessOK = false;
            }

            // Check Middle
            if (verifyProcessOK && this.card.indexOf('^')<5) {
                verifyProcessOK = false;
            }

            // Get Date
            if (verifyProcessOK) {
                posDate = this.card.search("=");
                if (posDate == -1) {
                    verifyProcessOK = false;
                }else{
                    cardExpirationMonth = this.card.substring(posDate+3,posDate+5)+"";
                    cardExpirationYear = this.card.substring(posDate+1,posDate+3)+"";
                    cardExpiration = cardExpirationMonth+cardExpirationYear;
                }
            }

            // Get Name
            if (verifyProcessOK) {
                posName = this.card.indexOf('^');
                if (posName == -1) {
                    verifyProcessOK = false;
                }else{
                    posName_2 = this.card.indexOf('/');
                    if (posName_2 == -1) {
                        verifyProcessOK = false;
                    }else{
                        lastName = this.card.substring(posName+1,posName_2);
                        nameOnCard = this.card.substring(posName+1);
                        posLastName = nameOnCard.indexOf('^');
                        if (posLastName == -1) {
                            verifyProcessOK = false;
                        }else{
                            posName2 = nameOnCard.indexOf('/');
                            if (posName2 == -1) {
                                verifyProcessOK = false;
                            }else{
                                name = nameOnCard.substring(posName2+1,posLastName);
                                cardName = name.trim()+" "+lastName.trim();
                            }
                        }
                    }
                }
            }

            // Get Number
            if (verifyProcessOK) {
                posNumber = this.card.indexOf('^');
                if (posName == -1) {
                    verifyProcessOK = false;
                } else {
                    cardNumber = this.card.substr(2, (posNumber - 2));
                }
            }

            // Check all fields
            if (verifyProcessOK) {
                if (!cardExpiration || !cardNumber || !cardName){
                    verifyProcessOK = false;
                }
            }

            /*
            if (!verifyProcessOK && this.numRetryCard == 1){
                // Retry
                this.requestContent = this.card;
                this.checkTimeOut();
            }else {
                if (!verifyProcessOK) {
                    this.errorWhilePayment = true;
                    this.responseContent = this.card;

                    let toast = this.toastCtrl.create({
                        message: "Swipe a Valid Credit Card",
                        position: 'middle',
                        duration: 3000
                    });
                    toast.present();
                    this.card = null;
                    this.inputCard.setFocus();
                    this.checkTimeOut();
                } else {
                    this.makePayment(cardNumber, cardExpiration, cardName, null);
                }
            }
            */

            if (!verifyProcessOK) {
                //console.log(this.card);
                this.checkTimeOut();
            }else{
                this.makePayment(cardNumber, cardExpiration, cardName, null);
            }

        }else{
            this.inputCard.setFocus();
            this.checkTimeOut();
        }
    }


    /**
     * @Info Send Payment
     * @accept: parameters
     * @return: response
     * @author: sev
     * @date  : 2017-10-22
     */
    makePayment(cardNumber, cardExpiration, cardName, cvv){

        this.errorWhilePayment = false;
        if (!this.processingTransaction){
            this.getTotals(); //

            this.processingTransaction = true;
            this.loader = this.loadingCtrl.create({
                content: "Please wait...",
                duration: 90000
            });
            this.loader.present();

            try {
                let itemsToSend = [];
                this.sellItems.forEach(item => {
                    itemsToSend.push({IdItem: item.idItem, Quantity: item.quantity});
                });

                let idUser = 1;
                if (this._configuration.isLogged){
                    idUser = this._configuration.CustomerData.IdUser;
                }

                let cardSwipeData = this.card;
                let EmployeeId = this.employeeData.IdEmployee;
                let paymentTypeToSend = 0;
                if (this.paymentType == 1){
                    // Swipe
                    paymentTypeToSend = 1;
                }else if (this.paymentType == 2){
                    // Manual CC
                    paymentTypeToSend = 1;
                    cardSwipeData = "";
                }else if (this.paymentType == 3){
                    // Employee
                    paymentTypeToSend = 2;
                    //EmployeeId = this.employeeData.IdEmployee;
                    cardNumber = "";
                    cardExpiration = "";
                    cardName = "";
                    cvv = "";
                    cardSwipeData = "";
                }
                if (!cardNumber){
                    cardNumber = "";
                }
                if (!cvv){
                    cvv = "";
                }

                // No Round
                /*
                let amt = this.total.toFixed(3);
                let amtTax = this.totalTaxofItems.toFixed(3);
                this.amount = amt.substr(0,amt.length-1);
                this.taxAmount = amtTax.substr(0,amtTax.length-1);
                */
                // With Round
                //this.amount = this.total.toFixed(2);
                //this.taxAmount = this.totalTaxofItems.toFixed(2);
                this.amount = this.total+"";
                this.taxAmount = this.totalTaxofItems+"";

                let data = {
                    IdUser: idUser,
                    TotalAmount: this.amount,
                    TotalTax : this.taxAmount,
                    IdEmployee: EmployeeId,
                    PaymentType: paymentTypeToSend,
                    token: this._configuration.token,
                    Creditcard: {
                        CCard: cardNumber,
                        CCardDate: cardExpiration,
                        CCardName: cardName,
                        CCardCVV: cvv,
                        Swipe: cardSwipeData
                    },
                    Items: itemsToSend
                };
                //console.log(data)
                this.requestContent = data;
                this.paymentService.payment(data)
                    .then(data => {
                        this.loader.dismiss();
                        let response : any = data;
                        this.responseContent = data;

                        setTimeout(() => {
                            this.processingTransaction = false;
                        }, 3000);

                        this.processingTransaction = false;
                        if (!response.Error){
                            if (response.Success){
                                let paymentDetails : any= {};
                                if ((this.paymentType == 1 || this.paymentType == 2) && response.Content.paymentsDetails){
                                    paymentDetails = response.Content.paymentsDetails[0];
                                }else{
                                    paymentDetails = {
                                        paytype: 0,
                                        acctname: "CREDIT",
                                        acct: "",
                                        amount: this.amount,
                                        authcode: "",
                                        pnref: ""
                                    };
                                }
                                paymentDetails.invoiceNumber = response.Content.invoiceNumber;
                                paymentDetails.paymentType = this.paymentType;
                                paymentDetails.taxAmount = this.taxAmount;
                                paymentDetails.applyForDiscount = this.applyForDiscount;
                                paymentDetails.employeeData = this.employeeData;

                                this.navParams.data.paymentDetails = paymentDetails;
                                this.navParams.data.tab1Enabled = false;
                                this.navParams.data.tab2Enabled = false;
                                this.navParams.data.tab3Enabled = true;
                                this.navCtrl.parent.select(2);
                            }else{
                                this.errorWhilePayment = true;
                                console.log(response);
                                let toast = this.toastCtrl.create({message: response.Message,position: 'middle',duration: 3000});
                                toast.present();
                                this.selectPaymentType(this.paymentType);
                            }
                        }else{
                            this.errorWhilePayment = true;
                            console.log(response);
                            let toast = this.toastCtrl.create({message: response.ErrorMessage,position: 'middle',duration: 3000});
                            toast.present();
                            this.selectPaymentType(this.paymentType);
                        }
                    });
            }
            catch(err) {
                this.loader.dismiss();
                this.errorWhilePayment = true;
                this.responseContent = err.message;
                console.log(err.message);
                let toast = this.toastCtrl.create({message: "An error has occurred",position: 'middle',duration: 3000});
                toast.present();
            }

        }
    }



    /**
     * @Info Get all totals
     * @accept: parameters
     * @return: response
     * @author: sev
     * @date  : 2017-10-22
     */
    getTotals(){
        this.numItems = 0;
        this.totalItems = 0;
        this.totalTaxofItems = 0;
        this.total = 0;
        this.totalDiscount = 0;
        if (this.sellItems.length > 0) {
            this.sellItems.forEach(item => {
                this.numItems = this.numItems + item.quantity;
                this.totalDiscount = this.totalDiscount + item.totalItemDiscount;
                if (this.applyForDiscount && item.unitPriceWD){
                    //this.totalItems = this.totalItems + item.totalPriceAllItemsWithoutTaxWD;
                    this.totalItems = this.totalItems + item.totalPriceAllItemsWithoutTax;

                    this.totalTaxofItems = this.totalTaxofItems + item.totalTaxWD;
                    this.total = this.total + item.totalWD;
                }else{
                    this.totalItems = this.totalItems + item.totalPriceAllItemsWithoutTax;
                    this.totalTaxofItems = this.totalTaxofItems + item.totalTax;
                    this.total = this.total + item.total;
                }
            });
        }
    }


    /**
     * @Info Select payment type
     * @accept: parameters
     * @return: response
     * @author: sev
     * @date  : 2017-10-24
     */
    selectPaymentType(payType){
        this.paymentType = payType;
        if (this.paymentType == 1){ // Credit with swipe
            this.applyForDiscount = false;
            this.employeeCode = "";
            this.employeeData = {};

            this.card = null;
            this.inputCard.setFocus();
            this.checkItems();
        }
        if (this.paymentType == 2){ // Credit card entering data
            this.applyForDiscount = false;
            this.employeeCode = "";
            this.employeeData = {};
            /*
            const modalData = {creditCard: this.creditCard};
            let modal = this.modalCtrl.create("ModalEnterCreditcardPage", { data: modalData });
            modal.onDidDismiss(data => {
                if (data){
                    if (data.reaload){
                        this.creditCard = data.creditCard;
                        //this.completeEnteringCreditCard();
                        this.makePayment(this.creditCard.number, this.creditCard.expDate, this.creditCard.name, this.creditCard.cvv);
                    }
                }
            });
            modal.present();
            */
        }
        if (this.paymentType == 3){ // EmployeeId credit on account
            //this.inputEmployeeCode.setFocus();
        }
        if (this.paymentType == 4){ // EmployeeId and credit card
            this.paymentType = 1;
            this.card = null;
            this.inputCard.setFocus();
            this.checkItems();
        }
        this.getTotals();
    }


    /**
     * @Info verify Employee by cod
     * @accept: parameters
     * @return: response
     * @author: sev
     * @date  : 2017-10-24
     */
    verifyEmployee(){
        if (!this.employeeCode) {
            let toast = this.toastCtrl.create({message: "Enter Employee Code",position: 'middle',duration: 3000});
            toast.present();
        }else{
            this.employeeData = {};
            let data = {IdEmployee: 0, EmployeeCod: this.employeeCode, token: this._configuration.token};
            this.employeeService.read(data)
                .then(data => {
                    let response : any = data;
                    if (!response.Error){
                        if (response.Success){
                            this.employeeData = response.Content[0];
                            this.applyForDiscount = true;
                            this.getTotals();
                        }else{
                            let toast = this.toastCtrl.create({message: response.Message,position: 'middle',duration: 3000});
                            toast.present();
                        }
                    }else{
                        let toast = this.toastCtrl.create({message: response.ErrorMessage,position: 'middle',duration: 3000});
                        toast.present();
                    }
                });
        }
    }


    /**
     * @Info Complete purchase by employee id
     * @accept: parameters
     * @return: response
     * @author: sev
     * @date  : 2017-10-24
     */
    completeByEmployeeCod(){
        if (!this.employeeCode || !this.employeeData.Name) {
            let toast = this.toastCtrl.create({message: "Verify Employee Code",position: 'middle',duration: 3000});
            toast.present();
        }else{
            this.makePayment(null, null, null, null);
        }
    }


    /**
     * @Info Complete purchase by employee id and credit card
     * @accept: parameters
     * @return: response
     * @author: sev
     * @date  : 2017-11-01
     */
    completeByEmployeeCodAndCreditCard(){
        if (!this.employeeCode || !this.employeeData.Name) {
            let toast = this.toastCtrl.create({message: "Verify Employee Code",position: 'middle',duration: 3000});
            toast.present();
        }else{
            this.selectPaymentType(4);
        }
    }


    /**
     * @Info Complete purchase entering the credit card information
     * @accept: parameters
     * @return: response
     * @author: sev
     * @date  : 2017-10-24
     */
    completeEnteringCreditCard(){
        let msg = "";
        if (!this.creditCard.number) {
            msg = "Enter Credit Card Number";
        }
        if (!msg && !this.creditCard.name) {
            msg = "Enter Name On Credit Card";
        }
        if (!msg && !this.creditCard.expDate) {
            msg = "Enter Credit Card Expiration Date";
        }
        if (!msg && this.creditCard.expDate && this.creditCard.expDate.length!=4) {
            msg = "Enter a Valid Credit Card Expiration Date: MMYY (Month and Year)";
        }
        if (!msg && this.creditCard.expDate && this.creditCard.expDate.length==4) {
            let month = this.creditCard.expDate.substr(0,2);
            if (month < 1 || month > 12){
                msg = "Enter a Valid Credit Card Expiration Date: MMYY: Month and Year, Example: 0624 (Jun 2024)";
            }
        }
        if (!msg && !this.creditCard.cvv) {
            msg = "Enter Credit Card CVV";
        }

        if (msg){
            let toast = this.toastCtrl.create({message: msg,position: 'middle',duration: 3000});
            toast.present();
        }else{
            this.makePayment(this.creditCard.number, this.creditCard.expDate, this.creditCard.name, this.creditCard.cvv);
        }

    }

}



// WEBPACK FOOTER //
// ./src/pages/payment/payment.ts